import React, { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { RHFCombobox } from '@/Components/shadcn/rhf-combobox';
import { Currency } from '@/Models/Currency';
import UIStrings from '@/Utils/UIStrings';
import { JobDetailsFieldTypes, useJobDetailsForm } from '../JobDetailsStepUtils';

interface CurrencyAutocompleteProps {
    currencies: Array<Currency>;
}

function CurrencyAutocomplete({ currencies }: CurrencyAutocompleteProps): React.JSX.Element {
    const { setValue, control } = useJobDetailsForm();
    const { doNotDisplaySalary } = useWatch({ control });

    useEffect(() => {
        if (doNotDisplaySalary) {
            setValue('currency', { id: '', label: '' }, { shouldTouch: false, shouldValidate: true });
        }
    }, [doNotDisplaySalary, setValue]);

    return (
        <div className="flex flex-1">
            <RHFCombobox<Currency>
                name={JobDetailsFieldTypes.Currency}
                label={`${UIStrings.Currency}*`}
                options={currencies}
                disabled={doNotDisplaySalary}
                fieldDataCy="currency"
                hideFieldError
                emptyValue={{ id: '', label: '' }}
            />
        </div>
    );
}

export default CurrencyAutocomplete;
